export const VIBECODING_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes
  gcTime: 30 * 60 * 1000, // 30 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};

// Config pour les endpoints lourds (analytics, comparison)
// Le cache DB est rafraîchi toutes les heures → staleTime plus long acceptable
export const VIBECODING_HEAVY_QUERY_CONFIG = {
  staleTime: 30 * 60 * 1000, // 30 minutes
  gcTime: 60 * 60 * 1000, // 1 heure
  refetchOnWindowFocus: false,
  retry: 1,
};

export const AUDIT_QUERY_CONFIG = {
  staleTime: 2 * 60 * 1000, // 2 minutes
  gcTime: 15 * 60 * 1000, // 15 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};

// Ailix Transfer : liens + fichiers (admin). Données peu volatiles entre actions,
// invalidées explicitement après mutation (création/suppression/upload).
export const TRANSFER_QUERY_CONFIG = {
  staleTime: 60 * 1000, // 1 minute
  gcTime: 10 * 60 * 1000, // 10 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};

export const INTERNAL_ASSETS_QUERY_CONFIG = {
  staleTime: 3 * 60 * 1000, // 3 minutes
  gcTime: 15 * 60 * 1000, // 15 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};

export const CLIENT_DATA_QUERY_CONFIG = {
  staleTime: 60 * 1000, // 1 minute: supporte la navigation chaude sans refetch immédiat
  gcTime: 10 * 60 * 1000, // 10 minutes: garde le cache partagé entre pages
  refetchOnWindowFocus: false,
  retry: false,
};

export const SYNTHESIS_QUERY_CONFIG = {
  staleTime: 2 * 60 * 1000, // 2 minutes: données plus sensibles aux modifications de sélection
  gcTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: false,
};

export const HOME_KPI_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000, // 5 minutes: KPI pré-calculés, changent rarement
  gcTime: 30 * 60 * 1000, // 30 minutes
  refetchOnWindowFocus: false,
  retry: 1,
};

// Monitoring : overview auto-rafraîchi (~30s), cache d'inventaire court côté backend
export const MONITORING_OVERVIEW_QUERY_CONFIG = {
  staleTime: 20 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchInterval: 30 * 1000,
  retry: 1,
};

// Monitoring : logs en quasi temps réel (polling ~5s, jamais de cache long)
export const MONITORING_LOGS_QUERY_CONFIG = {
  staleTime: 0,
  gcTime: 60 * 1000,
  refetchOnWindowFocus: false,
  refetchInterval: 5 * 1000,
  retry: 1,
};

// Monitoring : alertes (bandeau dashboard) — rafraîchissement ~30s
export const MONITORING_ALERTS_QUERY_CONFIG = {
  staleTime: 15 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  refetchInterval: 30 * 1000,
  retry: 1,
};

// Monitoring : règles d'alerte (édition rare → cache plus long)
export const MONITORING_RULES_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000,
  gcTime: 15 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};

// Monitoring : métriques (graphes tendance) — cache court, refetch manuel/auto.
export const MONITORING_METRICS_QUERY_CONFIG = {
  staleTime: 30 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};

// Monitoring : fiabilité/reporting — calcul lourd, change lentement (cache 5 min).
export const MONITORING_RELIABILITY_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000,
  gcTime: 15 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};

// Monitoring : coûts & capacité — données lourdes, peu volatiles (recalcul à la collecte)
export const MONITORING_COSTS_QUERY_CONFIG = {
  staleTime: 5 * 60 * 1000,
  gcTime: 30 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};

// Monitoring : journal d'audit des actions (M6) — consultation, cache moyen.
export const MONITORING_ACTIONS_LOG_QUERY_CONFIG = {
  staleTime: 30 * 1000,
  gcTime: 5 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};

// Relecture des features (file « À valider ») : la file change à chaque décision, cache court ;
// le retry est posé par le hook (jamais sur 403/404/422).
export const VIBECODING_REVIEW_QUERY_CONFIG = {
  staleTime: 30 * 1000,
  gcTime: 10 * 60 * 1000,
  refetchOnWindowFocus: false,
  retry: 1,
};
